import {
  SORTING,
  HIDDEN_SORTING,
  DEFAULT_SORT_BY,
  SORT_BY_POI_VALUE
} from '../constants';

const HIDDEN_SORTING_OPTIONS = Object.keys(HIDDEN_SORTING).map(
  key => HIDDEN_SORTING[key]
);
const HIDDEN_SORTING_VALUES = HIDDEN_SORTING_OPTIONS.map(
  option => option.value
);
const AVAILABLE_SORTING_OPTIONS = Object.keys(SORTING).map(key => SORTING[key]);
const AVAILABLE_SORTING_VALUES = AVAILABLE_SORTING_OPTIONS.map(
  option => option.value
);

export const getSortingOptions = () => AVAILABLE_SORTING_OPTIONS;

export const getHiddenSortingConfig = value =>
  HIDDEN_SORTING_OPTIONS.find(sort => value === sort.value);

export const isDefaultSort = value => {
  const isDefault = value === DEFAULT_SORT_BY;
  const isUnknown =
    !AVAILABLE_SORTING_VALUES.includes(value) &&
    !HIDDEN_SORTING_VALUES.includes(value);
  return isDefault || isUnknown;
};

export const isSortByPOI = value => value === SORT_BY_POI_VALUE;

export const getDefaultSortBy = () => DEFAULT_SORT_BY;

export const getSortingName = (sortByValue, variantName) =>
  isDefaultSort(sortByValue) && variantName ? variantName : sortByValue;

export default {
  isDefaultSort,
  getHiddenSortingConfig,
  getSortingOptions,
  getSortingName,
  isSortByPOI,
  getDefaultSortBy
};
